import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { MdOpenInNew } from 'react-icons/md';

import fpadiLogo from '../../assets/fpadi.png';
import groupvLogo from '../../assets/groupv.png';
import jiezhiLogo from '../../assets/jiezhi.png';
import jengaLogo from '../../assets/jenga.png';
import kobeLogo from '../../assets/kobe.png';
import lugaloLogo from '../../assets/lugalo.png';
import zamaniLogo from '../../assets/zamani.png';

import kwetuLogo from '../../assets/kwetuAfrica.png';
import nassaLogo from '../../assets/nassa.png';
import ncclLogo from '../../assets/nccl.png';
import kabalenziLogo from '../../assets/kabalenzi.png';
import kjLogo from '../../assets/kjConsult.png';
import kitchenKingsLogo from '../../assets/kitchenKings.png';
import familyFarmersLogo from '../../assets/familyFarmers.png';
import tchiLogo from '../../assets/tachi.png';
import coraggioLogo from '../../assets/coraggio.png';
import ckmLogo from '../../assets/ckm.png';
import vanessa1 from '../../assets/vanessa1.png';
import vanessa2 from '../../assets/vanessa2.png';
import ebtos from '../../assets/ebtos.png';
import kinemo from '../../assets/kinemo.png';
import tasaso from '../../assets/tasaso.png';
import franno from '../../assets/franno.png';
import tyidi from '../../assets/tyidi.png';
import namburiLogo from '../../assets/namburi.png';
import isiringitiLogo from '../../assets/isiringiti.jpg';
import decoTransportLogo from '../../assets/deco.png';
import gvpLogo from '../../assets/gvp.png';
import scienceTownLogo from '../../assets/science.png';
import fimacyLogo from '../../assets/fimacy.png';

const websites = [
  {
    name: 'FPADI',
    url: 'https://fpadi.org/',
    category: 'NGO',
    logo: fpadiLogo,
    desc: 'Disability rights advocacy and inclusive development initiatives for Tanzania.'
  },
  {
    name: 'GroupV Construction Materials',
    url: 'http://groupv.co.tz/',
    category: 'Construction materials',
    logo: groupvLogo,
    desc: 'Distribution center for construction supplies with pricing and delivery details.'
  },
  {
    name: 'GVP Construction',
    url: 'https://gvp.co.tz/',
    category: 'Construction',
    logo: gvpLogo,
    desc: 'Construction partner delivering infrastructure, materials, and site services.'
  },
  {
    name: 'Deco Transport',
    url: 'https://decotransport.co.tz/',
    category: 'Transportation',
    logo: decoTransportLogo,
    desc: 'Freight and transportation services with dedicated fleet tracking.'
  },
  {
    name: 'Science Town',
    url: 'https://sciencetown.co.tz/',
    category: 'Food supply',
    logo: scienceTownLogo,
    desc: 'Food supply and agro-processing brand paving the way for safe meals.'
  },
  {
    name: 'Fimacy Technologies',
    url: 'https://fimacy.co.tz/',
    category: 'IT',
    logo: fimacyLogo,
    desc: 'IT services and software delivery studio serving enterprises across Tanzania.'
  },
  {
    name: 'Jiezhi Global',
    url: 'https://www.jiezhiglobal.com/',
    category: 'Electronics supply',
    logo: jiezhiLogo,
    desc: 'Electronics components partner portal showcasing global reach and products.'
  },
  {
    name: 'Franno Ltd',
    url: 'https://frannoltd.com/',
    category: 'Electrical',
    logo: franno,
    desc: 'Electrical contracting services with project highlights and contact information.'
  },
  {
    name: 'Jenga Construction',
    url: 'https://jengaconstruction.com/',
    category: 'Construction',
    logo: jengaLogo,
    desc: 'Construction firm featuring recent builds and capabilities.'
  },
  {
    name: 'Kinemo Agro',
    url: 'http://kinemoagro.com/',
    category: 'Agriculture',
    logo: kinemo,
    desc: 'Agricultural input provider delivering modern farming solutions.'
  },
  {
    name: 'Kobe Konsult',
    url: 'https://kobekonsult.com/',
    category: 'Consultation',
    logo: kobeLogo,
    desc: 'Consulting firm landing page that highlights advisory services.'
  },
  {
    name: 'Lugalo Consult',
    url: 'https://lugaloconsultants.co.tz/',
    category: 'Consultation',
    logo: lugaloLogo,
    desc: 'Capacity building and business advisory services showcased clearly.'
  },
  {
    name: 'Safina Logistics',
    url: 'https://safina.co.tz/',
    category: 'Logistics',
    logo: null,
    desc: 'Logistics and freight services portal with clear service breakdown.'
  },
  {
    name: 'Zamani Sabios',
    url: 'https://zamanisabios.com/',
    category: 'Consultation',
    logo: zamaniLogo,
    desc: 'Strategy consultancy featuring thought leadership and services.'
  },
  {
    name: 'Vanessa Foundation',
    url: 'https://vanessafoundation.or.tz/',
    category: 'NGO',
    logo: vanessa2,
    desc: 'Foundation impact stories, programs, and supporter resources.'
  },
  {
    name: 'Tasaso',
    url: 'https://tasaso.or.tz/',
    category: 'NGO',
    logo: tasaso,
    desc: 'Rural development NGO highlighting programs and community partners.'
  },
  {
    name: 'Vanessa Labour Based Women Tech',
    url: 'https://vanessalabourbasedwomantech.co.tz/',
    category: 'NGO',
    logo: vanessa1,
    desc: 'Women-led labour based technology initiative with program details.'
  },
  {
    name: 'TYDI',
    url: 'https://tyidi.or.tz/',
    category: 'NGO',
    logo: tyidi,
    desc: 'Youth development and empowerment organization sharing programs.'
  },
  {
    name: 'Ebtos',
    url: 'https://ebtos.co.tz/',
    category: 'Construction',
    logo: ebtos,
    desc: 'Construction, civil works, and equipment services overview.'
  },
  {
    name: 'Namburi Seeds Co.',
    url: 'https://namburiseeds.co.tz',
    category: 'Seed Supply',
    logo: namburiLogo,
    desc: 'Supplier of high-quality seeds equipped with farmer resources.'
  },
  {
    name: 'Kwetu Africa Adventures',
    url: 'https://kwetuafricaadventures.com',
    category: 'Tourism',
    logo: kwetuLogo,
    desc: 'Safari and adventure operator showcasing curated travel packages.'
  },
  {
    name: 'Nassa Consult',
    url: 'https://nassaconsult.co.tz',
    category: 'Consultancy',
    logo: nassaLogo,
    desc: 'Business strategy and project management consultancy services.'
  },
  {
    name: 'Nahdi Crusher Company Limited',
    url: 'https://nccl.tz',
    category: 'Transportation',
    logo: ncclLogo,
    desc: 'Corporate site for limestone transportation and crushing services.'
  },
  {
    name: 'Kabalenzi Enterprises',
    url: 'https://kabalenzienterprises.co.tz',
    category: 'Mining',
    logo: kabalenziLogo,
    desc: 'Mining and extraction site that highlights operations and partnerships.'
  },
  {
    name: 'KJ Consultants',
    url: 'https://kjconsultancy.co.tz',
    category: 'Consultation',
    logo: kjLogo,
    desc: 'Business advisory hub for corporate clients and startups.'
  },
  {
    name: 'Kitchen Kings',
    url: 'https://kitchenkings.co.tz',
    category: 'Carpentry',
    logo: kitchenKingsLogo,
    desc: 'Portfolio of high-end carpentry and bespoke kitchen builds.'
  },
  {
    name: 'The Family Farmers',
    url: 'https://thefamilyfarmers.co.tz',
    category: 'Agriculture',
    logo: familyFarmersLogo,
    desc: 'Sustainable farming brand with product showcase and recipes.'
  },
  {
    name: 'Tanzania Children Hope Innovations',
    url: 'https://tchi.or.tz',
    category: 'NGO',
    logo: tchiLogo,
    desc: 'Nonprofit platform sharing impact, programs, and donation channels.'
  },
  {
    name: 'Isiringiti Fish Cages',
    url: 'https://isiringitifishhub.co.tz',
    category: 'Aquaculture',
    logo: isiringitiLogo,
    desc: 'Fish cage innovation portal detailing technology and partners.'
  },
  {
    name: 'Coraggio Security',
    url: 'https://coraggiosecurity.co.tz',
    category: 'Security',
    logo: coraggioLogo,
    desc: 'Security firm site outlining services and rapid response teams.'
  },
  {
    name: 'CKM Company',
    url: 'https://ckmcompany.co.tz',
    category: 'Electrical',
    logo: ckmLogo,
    desc: 'Electrical installations and services portfolio for clients.'
  }
];

const getHostname = (link = '') => {
  try {
    return new URL(link).hostname;
  } catch (error) {
    return link.replace(/^https?:\/\//, '').replace(/\/.*$/, '');
  }
};

export default function Websites() {
  return (
    <div
      className="websites-page bg-primary"
      style={{
        background: `radial-gradient(circle at 10% -40%, rgba(14, 165, 233, 0.35), transparent 45%),
          radial-gradient(circle at 80% -20%, rgba(59, 130, 246, 0.2), transparent 40%),
          linear-gradient(180deg, #0b1224, #050909)`,
        minHeight: '100vh',
        paddingTop: '3rem',
        paddingBottom: '3rem'
      }}
    >
      <div className="container py-5 position-relative">
        <div className="text-center text-light mb-5">
          <p className="text-uppercase fw-semibold mb-1" style={{ letterSpacing: '0.4rem' }}>
            Portfolio
          </p>
          <h1 className="font-bold text-secondary" style={{ fontSize: 'clamp(2.25rem, 4vw, 3.25rem)' }}>
            Websites We've Built
          </h1>
          
        </div>

        <div className="row g-4">
          {websites.map((site) => (
            <div key={site.name} className="col-12 col-md-6 col-xl-4">
              <div
                className="h-100 d-flex flex-column p-4 rounded-4"
                style={{
                  background: 'linear-gradient(180deg, #ffffff, #f7f9ff 60%)',
                  border: '1px solid rgba(59, 130, 246, 0.25)',
                  boxShadow: '0 25px 45px rgba(2, 6, 23, 0.25)',
                  minHeight: '360px'
                }}
              >
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div
                    className="rounded-4 d-flex align-items-center justify-content-center"
                    style={{
                      width: '64px',
                      height: '64px',
                      background: 'linear-gradient(120deg, rgba(59, 130, 246, 0.18), rgba(16, 185, 129, 0.12))'
                    }}
                  >
                    {site.logo ? (
                      <img
                        src={site.logo}
                        alt={`${site.name} logo`}
                        style={{ width: '48px', height: '48px', objectFit: 'contain' }}
                      />
                    ) : (
                      <span className="text-muted small">Logo</span>
                    )}
                  </div>

                  <span
                    className="text-uppercase fw-semibold p-2 bg-primary rounded"
                    style={{
                      fontSize: '0.7rem',
                      color: 'rgba(59, 130, 246, 0.85)'
                    }}
                  >
                    {site.category}
                  </span>
                </div>

                <h5 className="fw-bold text-primary mb-2" style={{ fontSize: '1.2rem' }}>
                  {site.name}
                </h5>

                <p className="text-muted flex-grow-1 font-semi-bold" style={{ lineHeight: 1.6 }}>
                  {site.desc}
                </p>

                <div className="mt-4">
                  <a
                    href={site.url}
                    target="_blank"
                    rel="noreferrer"
                    className="btn rounded-pill d-inline-flex align-items-center gap-2 bg-secondary"
                    style={{
                      fontWeight: 600,
                      color: '#fff',
                      border: 'none',
                      padding: '0.55rem 1.4rem'
                    }}
                  >
                    <span>View Website</span>
                    <MdOpenInNew size={16} />
                  </a>
                  <div className="text-muted small mt-2" style={{ letterSpacing: '0.1rem' }}>
                    {getHostname(site.url)}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
